import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _vm.gds_report.length == 0
        ? _c("StateComponent", {
            attrs: {
              state: "empty_state",
              title: _vm.$t("my_objects.states_objects.no_reports_lds"),
              subtitle: _vm.$t(
                "my_objects.states_objects.no_reports_lds_subtitle"
              ),
            },
          })
        : _c(
            VCard,
            [
              _c(VDataTable, {
                staticClass: "text-center table-inca",
                style: { "font-size": "11px" },
                attrs: {
                  responsive: "",
                  hover: "",
                  headers: _vm.reportFields,
                  items: _vm.gds_report,
                  "per-page": _vm.pagination.limit,
                  page: _vm.pagination.current,
                  "hide-default-footer": true,
                  "show-empty": "",
                  busy: _vm.isBusy,
                  search: _vm.filter,
                  "items-per-page": _vm.pagination.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination, "current", $event)
                  },
                  pagination: function ($event) {
                    _vm.pagination.total = $event.itemsLength
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "table-busy",
                    fn: function (scope) {
                      return [
                        _c("strong", [_vm._v(_vm._s(_vm.messageLoading))]),
                      ]
                    },
                  },
                  {
                    key: "empty",
                    fn: function (scope) {
                      return [
                        _c("strong", [_vm._v(_vm._s(_vm.messageEmptyList))]),
                      ]
                    },
                  },
                  {
                    key: "item.object_name",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("div", { staticClass: "text-left" }, [
                          _c("b", [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.changeMetaReport(item, true)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.object_name))]
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.actions",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.isDataOperator(item) ||
                                                    (!_vm.isDataOperator(
                                                      item
                                                    ) &&
                                                      item.environment ===
                                                        "prod"),
                                                  expression:
                                                    "isDataOperator(item) || (!isDataOperator(item) && item.environment === 'prod')",
                                                },
                                              ],
                                              staticClass: "btn-icon-inca",
                                              attrs: { icon: "", small: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.changeMetaReport(
                                                    item,
                                                    false
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            VIcon,
                                            { attrs: { small: "" } },
                                            [_vm._v("icon-edit")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("my_objects.update_metadata"))
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _vm.isDataOperator(item) &&
                                      item.environment === "prod"
                                        ? _c(
                                            VBtn,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "btn-icon-inca",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openTempOwner(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                VIcon,
                                                { attrs: { small: "" } },
                                                [_vm._v("mdi-account-multiple")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("my_objects.set_temporal_do"))
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _vm.isDataOperator(item)
                                        ? _c(
                                            VBtn,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "btn-icon-inca",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openLookerReport(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                VIcon,
                                                { attrs: { small: "" } },
                                                [_vm._v("mdi-open-in-new")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("my_objects.open_report_lds"))
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rol",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          VBtn,
                          {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover.right",
                                value: "Open",
                                expression: "'Open'",
                                modifiers: { hover: true, right: true },
                              },
                            ],
                            attrs: {
                              id: "'popover-open-pbi-' + " + item.report_id,
                              rounded: "",
                              outlined: "",
                              small: "",
                              dense: "",
                              color: "secondary",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isDataOperator(item),
                                    expression: "isDataOperator(item)",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("my_objects.data_operator"))
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isDataOperator(item),
                                    expression: "!isDataOperator(item)",
                                  },
                                ],
                              },
                              [_vm._v(_vm._s(_vm.$t("my_objects.viewer")))]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
      _c("pagination-vue", {
        attrs: { pagination: _vm.pagination },
        on: { changePagina: _vm.changePagina },
      }),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_REPORT,
          attrs: {
            title: !_vm.isReadonly
              ? _vm.$t("my_objects.update_metadata")
              : _vm.$t("my_objects.metadata"),
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-report-datastudio", {
                ref: _vm.MODAL_NAME_REPORT + "_body",
                attrs: {
                  item: _vm.data_ds,
                  report_id: _vm.data_ds ? _vm.data_ds["report_id"] : "",
                  isChangeRequest: _vm.isReadonly
                    ? _vm.ACCESS_TYPE_FLOW.ACCESS
                    : _vm.ACCESS_TYPE_FLOW.CHANGE_METADATA,
                  readonly: _vm.isReadonly,
                  showButtons: !_vm.isReadonly,
                },
                on: { onCloseModal: _vm.onCloseModalReport },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsLeft" },
            [
              _vm.data_ds && _vm.data_ds.report_id
                ? _c(
                    VBtn,
                    {
                      attrs: {
                        outlined: "",
                        rounded: "",
                        color: "secondary",
                        dense: "",
                      },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_NAME_REPORT + "_body"
                          ].onDownloadCsv()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-download"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("btns.download_metadata"))),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              !_vm.isReadonly
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-2",
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[_vm.MODAL_NAME_REPORT + "_body"].onSave()
                        },
                      },
                    },
                    [
                      _c(
                        VIcon,
                        { staticClass: "md-16", attrs: { small: "" } },
                        [_vm._v("mdi-check-circle-outline")]
                      ),
                      _vm._v(_vm._s(_vm.$t("btns.accept"))),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_OWNER,
          attrs: { title: _vm.$t("my_objects.set_temporal_do") },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-assign-temporal-owner", {
                ref: _vm.MODAL_NAME_OWNER + "_body",
                attrs: { tplToWork: _vm.data_ds, type: "report_gds" },
                on: {
                  submitReport: _vm.assignOwner,
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_OWNER].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.MODAL_NAME_OWNER + "_body"].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { icon: "" } }, [_vm._v("icon-check")]),
                  _vm._v(_vm._s(_vm.$t("btns.assign"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_ALL_OWNER,
          attrs: { title: _vm.$t("my_objects.assign_all_do") },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-assign-temporal-owner", {
                ref: _vm.MODAL_NAME_ALL_OWNER + "_body",
                attrs: {
                  type: "report_gds",
                  records: _vm.gds_report,
                  isForAllOwners: true,
                },
                on: {
                  submitReport: _vm.assignAllOwner,
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_ALL_OWNER].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.MODAL_NAME_ALL_OWNER + "_body"].onSubmit(
                        $event
                      )
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { icon: "" } }, [
                    _vm._v("mdi-check-all"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.assign"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }